import { enqueueSnackbarAction } from 'actions/app.action';
import react from 'react';
import { useDispatch } from 'react-redux';

const useSnackbar = () => {
  const dispatch = useDispatch();
  function showSnackBar(message = '', error = '') {
    if (error) {
      dispatch(
        enqueueSnackbarAction({
          message: message,
          key: new Date().getTime() + Math.random(),
          variant: 'error',
        }),
      );
      return;
    }
    dispatch(
      enqueueSnackbarAction({
        message: message,
        key: new Date().getTime() + Math.random(),
        variant: 'success',
      }),
    );
  }

  return { showSnackBar };
};

export default useSnackbar;
